// @ts-nocheck
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import Minus from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus from "@store/Library/Components/Toolkit/Icons/Plus";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { filtersProps } from "@store/Themes/common/props/filters";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const _headerButtonBaseStyles = () => {
    return css`
        ${filtersProps.title?.css}
        /* Store Custom Code - Start */
        padding: ${filtersProps.spacing};
        background-color: ${getColor("common.accent")};
        /* Store Custom Code - End */
        border: none;
        /* Store Removed Code - border-top, border-bottom */
        color: inherit;
        transition: ${transitionHoverStyles("color")};
        margin: ${filtersProps.spacing} 0; /* Store Custom Code */

        &[aria-expanded="true"] {
            /* Store Custom Code - Start */
            border-bottom: 1px solid ${getColor("primary.contrast")};
            margin-bottom: 0; /* Store Custom Code */
            /* Store Custom Code - End */
        }

        &:hover {
            color: ${getColor("primary.main")};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${focusStyles(true)}
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionFilterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
            background-color: transparent;

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${filtersProps.borderWidth};
            }
        `,
    },
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: ${pxToRem(400)};
            padding: ${filtersProps.spacing}; /* Store Custom Code */
            border: none;
            /* Store Removed Code - border-bottom */
            background-color: ${getColor("common.accent")}; /* Store Custom Code */
        `,
    },
    toggleIconProps: {
        css: iconScalableStyles("1.5em"),
    },
    // Store Custom Code
    collapseIconProps: {
        src: Minus,
        color: "primary",
    },
    expandIconProps: {
        src: Plus,
        color: "primary",
    },
};
